import React, { Component } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default ({ text, children, id, containerClass, placement = "top" }) => {
  return (
    <OverlayTrigger
      //defaultShow={false}
      disabled={true}
      placement={placement}
      overlay={
        <Tooltip
          id={id}
          className={`modal-footer-tooltip ${containerClass}`}
          arrowProps={{ variant: false }}
        >
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
